// extracted by mini-css-extract-plugin
module.exports = {"quiz__title":"quiz-module--quiz__title--1cYQB","quiz__error":"quiz-module--quiz__error--zClf5","quiz__bottomgap":"quiz-module--quiz__bottomgap--3XAgf"};